// ------------------------------------ single product tab ----------------------------//

 (function initialiseLegacyTabs() {
  /* jQuery is not guaranteed to be available when this deferred asset starts.
     These optional legacy tabs must never block the storefront cart adapter. */
  if (!window.jQuery) return;

  window.jQuery(function () {
    window.jQuery('.tab').on('click', function () {
      var target = jQuery(this).data('tab');
      jQuery('.tab').removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.tab-content').removeClass('active');
      jQuery('#' + target).addClass('active');
    });

  
    jQuery('.accordion-header').on('click', function () {
      var parent = jQuery(this).parent();

      if (parent.hasClass('active')) {
        parent.removeClass('active');
        jQuery(this).find('.icon').text('+');
        jQuery(this).next('.accordion-body').slideUp(300);
      } else {
        jQuery('.accordion-item').removeClass('active');
        jQuery('.accordion-item .icon').text('+');
        jQuery('.accordion-body').slideUp(300);

        parent.addClass('active');
        jQuery(this).find('.icon').text('−');
        jQuery(this).next('.accordion-body').slideDown(300);
      }
    });
  });
})();

// ------------------------ review slider -----------------------------//
 if (typeof Swiper !== 'undefined' && document.querySelector('.reviews-slider')) {
  new Swiper('.reviews-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        centeredSlides: false,
      },
      576: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      768: {
        slidesPerView: 3,
         centeredSlides: false,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });
 }
// ------------------------ review slider -----------------------------//


//-------------------------new spotlight slider ---------------------------//

// Initialize the new spotlight slider
const spotlightSlider = typeof Swiper !== 'undefined' && document.querySelector('.new-spotlight-slider.swiper')
  ? new Swiper(".new-spotlight-slider.swiper ", {
  effect: "coverflow",
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 2,
  spaceBetween: 30,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3.1,
    slideShadows: false,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
  on: {
    slideChange: function () {
      // Pause the video of the previous slide when slide changes
      const previousSlide = this.slides[this.previousIndex];
      const previousVideo = previousSlide.querySelector("video");
      if (previousVideo) {
        previousVideo.pause();
        previousVideo.currentTime = 0;
      }

      // Get the video in the new active slide and start playing it
      const activeSlide = this.slides[this.activeIndex];
      const activeVideo = activeSlide.querySelector("video");
      if (activeVideo) {
        activeVideo.play();
        // Listen for the video end event to change the slide
        activeVideo.addEventListener("ended", () => {
          this.slideNext(); // Move to the next slide after video ends
        });
      }
    },
  },
  })
  : null;

// Pause autoplay on hover, resume on leave
const spotlightSliderContainer = document.querySelector(".new-spotlight-slider");

if (spotlightSliderContainer && spotlightSlider?.autoplay) {
  spotlightSliderContainer.addEventListener("mouseenter", () => {
    spotlightSlider.autoplay.stop();
  });

  spotlightSliderContainer.addEventListener("mouseleave", () => {
    spotlightSlider.autoplay.start();
  });
}

// Autoplay video of the first slide when page loads
document.addEventListener("DOMContentLoaded", function () {
  function ensureKuuraiiCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.open === "function") return drawer;

    /* Some embedded add-to-cart widgets can initialize before Shopify upgrades
       the cart-drawer custom element. Provide the same essential drawer API so
       those flows never fall through to the native /cart page. */
    drawer.setActiveElement = function (element) {
      this.activeElement = element;
    };
    drawer.open = function (trigger) {
      if (trigger) this.setActiveElement(trigger);
      this.classList.add("animate", "active");
      document.body.classList.add("overflow-hidden");
    };
    drawer.close = function () {
      this.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    };
    drawer.getSectionsToRender = function () {
      return [
        { id: "cart-drawer", selector: "#CartDrawer" },
        { id: "cart-icon-bubble" }
      ];
    };
    drawer.getSectionInnerHTML = function (html, selector) {
      const section = new DOMParser().parseFromString(html, "text/html").querySelector(selector || ".shopify-section");
      return section ? section.innerHTML : null;
    };
    drawer.renderContents = function (cartState, shouldOpen) {
      /* /cart/add.js returns the updated line items but not always item_count.
         Treat a missing count as an unknown state, never as an empty cart. */
      const hasItemCount = Number.isFinite(Number(cartState && cartState.item_count));
      const isEmpty = hasItemCount ? Number(cartState.item_count) === 0 : false;
      this.classList.toggle("is-empty", isEmpty);
      this.getSectionsToRender().forEach(function (section) {
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        const markup = cartState && cartState.sections && cartState.sections[section.id];
        if (!target || !markup) return;
        const html = drawer.getSectionInnerHTML(markup, section.selector);
        if (html !== null) target.innerHTML = html;
      });
      const inner = this.querySelector(".drawer__inner");
      if (inner) inner.classList.toggle("is-empty", isEmpty);
      if (shouldOpen !== false) this.open();
    };

    const overlay = drawer.querySelector("#CartDrawer-Overlay");
    if (overlay) overlay.addEventListener("click", function () { drawer.close(); });
    return drawer;
  }

  window.ensureKuuraiiCartDrawer = ensureKuuraiiCartDrawer;
  ensureKuuraiiCartDrawer();

  if (!spotlightSlider) return;
  const firstSlide = spotlightSlider?.slides?.[spotlightSlider.activeIndex];
  if (!firstSlide) return;

  const firstVideo = firstSlide.querySelector("video");
  if (firstVideo) {
    firstVideo.play();
    // Listen for the video end event to change the slide after the first video ends
    firstVideo.addEventListener("ended", () => {
      spotlightSlider.slideNext(); // Move to the next slide after first video ends
    });
  }
});

// ------------------------- New Spotlight Slider --------------------------- //

//-------------------------spotlight slider ---------------------------//

const swiper = typeof Swiper !== 'undefined' && document.querySelector('.spotlight-slider')
  ? new Swiper(".spotlight-slider", {
  effect: "coverflow",
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 2, 
  spaceBetween: 30,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3.1,
    slideShadows: false,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
// });


// // ✅ Pause autoplay on hover, resume on leave
// const swiperContainer = document.querySelector(".spotlight-slider");

// if (swiperContainer) {
//   swiperContainer.addEventListener("mouseenter", () => {
//     swiper.autoplay.stop();
//   });

//   swiperContainer.addEventListener("mouseleave", () => {
//     swiper.autoplay.start();
//   });
// }
  on: {
    slideChange: function () {
      // Pause the video of the previous slide when slide changes
      const previousSlide = this.slides[this.previousIndex];
      const previousVideo = previousSlide.querySelector("video");
      if (previousVideo) {
        previousVideo.pause();
        previousVideo.currentTime = 0; // Reset video playback
      }

      // Get the video in the new active slide and start playing it
      const activeSlide = this.slides[this.activeIndex];
      const activeVideo = activeSlide.querySelector("video");
      if (activeVideo) {
        activeVideo.play();
        // Listen for the video end event to change the slide
        activeVideo.addEventListener("ended", () => {
          this.slideNext(); // Automatically move to next slide after video ends
        });
      }
    },
  },
  })
  : null;

// ✅ Pause autoplay on hover, resume on leave
const swiperContainer = document.querySelector(".spotlight-slider");

if (swiperContainer && swiper?.autoplay) {
  swiperContainer.addEventListener("mouseenter", () => {
    swiper.autoplay.stop();
  });

  swiperContainer.addEventListener("mouseleave", () => {
    swiper.autoplay.start();
  });
}
//-------------------------spotlight slider ---------------------------//
window.addEventListener("load", function () {
  var wishlistDiv = document.querySelector('[data-block-handle="product_wishlist"]');
  var wishlistUL = wishlistDiv?.nextElementSibling;

  if (
    wishlistDiv &&
    wishlistUL &&
    wishlistUL.classList.contains("icon-with-text")
  ) {
    var wrapper = document.createElement("div");
    wrapper.className = "wwici__wishlist_notice";

    // Insert wrapper before wishlistDiv
    wishlistDiv.parentNode.insertBefore(wrapper, wishlistDiv);

    // Move both wishlistDiv and wishlistUL inside the wrapper
    wrapper.appendChild(wishlistDiv);
    wrapper.appendChild(wishlistUL);
  }
});

// --------------------------------- Wrap the review and iconbox section on home page----------------------//
document.addEventListener("DOMContentLoaded", function () {
  const carouselSection = document.querySelector(".template-index section:has(.jdgm-carousel-wrapper)");
  const statsSection = document.querySelector(".template-index section:has(.stats-wrapper)");

  if (carouselSection && statsSection) {
    // Create the wrapper
    const wrapper = document.createElement("div");
    wrapper.className = "unified-bg-wrapper";

    // Insert wrapper before the first section
    carouselSection.parentNode.insertBefore(wrapper, carouselSection);

    // Move both sections into the wrapper
    wrapper.appendChild(carouselSection);
    wrapper.appendChild(statsSection);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const carouselSection2 = document.querySelector(".template-product section:has(.bamboo-fabric-section)");
  const statsSection2 = document.querySelector(".template-product section:has(.stats-wrapper)");

  if (carouselSection2 && statsSection2) {
    // Create the wrapper
    const wrapper2 = document.createElement("div");
    wrapper2.className = "unified-bg-wrapper";

    // Insert wrapper2 before the first section
    carouselSection2.parentNode.insertBefore(wrapper2, carouselSection2);

    // Move both sections into the wrapper2
    wrapper2.appendChild(carouselSection2);
    wrapper2.appendChild(statsSection2);
  }
});

// --------------------------------- Change the placholder for search input on mobile----------------------//

function updatePlaceholder() {
  const input = document.querySelector('.wwici-search-input');
  if (input) {
    if (window.innerWidth < 589) {
      input.placeholder = "Search";
    } else {
      input.placeholder = "Search for products, categories...";
    }
  }
}

// Run once when DOM is loaded
window.addEventListener('DOMContentLoaded', updatePlaceholder);

// Run on window resize
window.addEventListener('resize', updatePlaceholder);


// ------------------------------------------- Add Main Collection Class to Menu ------------------------------------------//

window.addEventListener("load", function () {
  setTimeout(function () {
    const uls = document.querySelectorAll('ul.huk_menu_submenu');
    uls.forEach(ul => {
      if (ul.querySelector('.li-main-collection')) {
        ul.classList.add('has-main-collection');
      }
    });
  }, 1000); // 1 second delay
});
// Popup

// --------------------------- Kuuraii redesign --------------------------- //
document.addEventListener("DOMContentLoaded", function () {
  /* Keep every ordinary /cart link (including links inserted by embedded
     commerce widgets) inside the single Kuuraii cart drawer. */
  document.addEventListener("click", function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const cartLink = event.target.closest("a[href]");
    if (!cartLink || cartLink.target || cartLink.hasAttribute("download")) return;

    const targetUrl = new URL(cartLink.href, window.location.origin);
    const nativeCartPath = window.routes && routes.cart_url ? routes.cart_url : "/cart";
    if (targetUrl.origin !== window.location.origin || targetUrl.pathname !== nativeCartPath) return;

    const drawer = window.ensureKuuraiiCartDrawer && window.ensureKuuraiiCartDrawer();
    if (!drawer || typeof drawer.open !== "function") return;

    event.preventDefault();
    drawer.open(cartLink);
  }, true);

  const collectionCartBars = Array.from(document.querySelectorAll("[data-collection-cartbar]"));
  const collectionQuickAdds = Array.from(document.querySelectorAll(".kr-add-form[data-collection-quick-add='true']"));
  const collectionShell = document.querySelector(".kr-food-shell");
  const collectionRailToggles = Array.from(document.querySelectorAll("[data-collection-rail-toggle]"));
  let collectionCartState = null;

  function indiaPromotionsEnabled() {
    return Boolean(window.Shopify && window.Shopify.country === "IN");
  }

  function setCollectionRailCollapsed(collapsed) {
    if (!collectionShell) return;

    collectionShell.classList.toggle("is-rail-collapsed", collapsed);
    collectionRailToggles.forEach(function (toggle) {
      toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
      toggle.setAttribute("aria-label", collapsed ? "Show categories" : "Hide categories");
    });
  }

  collectionRailToggles.forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      if (!window.matchMedia("(max-width: 900px)").matches || !collectionShell) return;
      setCollectionRailCollapsed(!collectionShell.classList.contains("is-rail-collapsed"));
    });
  });

  window.addEventListener("resize", function () {
    if (window.matchMedia("(min-width: 901px)").matches) {
      setCollectionRailCollapsed(false);
    }
  });

  if (collectionShell) {
    const collectionFooter = document.querySelector(".shopify-section-group-footer-group, footer.footer, footer");
    const collectionProducts = collectionShell.querySelector(".food-products");
    const collectionHeader = document.querySelector(".site-header");
    let footerBoundaryFrame = null;
    let lastRailTop = null;
    let lastFooterOffset = null;
    let lastFooterTight = null;

    function updateCollectionFooterBoundary() {
      footerBoundaryFrame = null;

      if (!window.matchMedia("(max-width: 900px)").matches) {
        document.body.style.removeProperty("--kc-rail-top");
        collectionShell.style.removeProperty("--kc-footer-offset");
        collectionShell.classList.remove("is-footer-tight");
        lastRailTop = null;
        lastFooterOffset = null;
        lastFooterTight = null;
        return;
      }

      /* At the top of the page, the static announcement keeps the sticky
         navigation lower. Follow its visible bottom edge until it scrolls
         away, then retain the normal 59px mobile header clearance. */
      const railTop = Math.max(
        59,
        Math.ceil(collectionHeader ? collectionHeader.getBoundingClientRect().bottom : 0)
      );
      if (railTop !== lastRailTop) {
        document.body.style.setProperty("--kc-rail-top", railTop + "px");
        lastRailTop = railTop;
      }

      if (!collectionProducts && !collectionFooter) {
        if (lastFooterOffset !== null) {
          collectionShell.style.removeProperty("--kc-footer-offset");
          lastFooterOffset = null;
        }
        if (lastFooterTight !== false) {
          collectionShell.classList.remove("is-footer-tight");
          lastFooterTight = false;
        }
        return;
      }

      const footerTop = collectionProducts
        ? collectionProducts.getBoundingClientRect().bottom
        : collectionFooter.getBoundingClientRect().top;
      const maximumFooterOffset = Math.max(0, window.innerHeight - railTop);
      /* Keep a small clearance so fractional layout rounding never lets the
         fixed rail or its toggle touch the footer. */
      const footerOffset = Math.round(
        Math.min(Math.max(window.innerHeight - footerTop + 2, 0), maximumFooterOffset)
      );

      if (footerOffset !== lastFooterOffset) {
        collectionShell.style.setProperty("--kc-footer-offset", footerOffset + "px");
        lastFooterOffset = footerOffset;
      }

      const footerTight = footerOffset >= maximumFooterOffset - 1;
      if (footerTight !== lastFooterTight) {
        collectionShell.classList.toggle("is-footer-tight", footerTight);
        lastFooterTight = footerTight;
      }
    }

    function scheduleCollectionFooterBoundary() {
      if (footerBoundaryFrame) return;
      footerBoundaryFrame = window.requestAnimationFrame(updateCollectionFooterBoundary);
    }

    updateCollectionFooterBoundary();
    window.addEventListener("scroll", scheduleCollectionFooterBoundary, { passive: true });
    window.addEventListener("resize", scheduleCollectionFooterBoundary);
  }

  function formatCollectionMoney(cents) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0
    }).format(Number(cents || 0) / 100);
  }

  function getCartItemForVariant(variantId) {
    if (!collectionCartState || !Array.isArray(collectionCartState.items)) return null;
    return collectionCartState.items.find(function (item) {
      return Number(item.variant_id) === Number(variantId);
    }) || null;
  }

  function syncCollectionQuickAddForms() {
    if (!collectionQuickAdds.length) return;

    collectionQuickAdds.forEach(function (form) {
      const variantId = Number(form.dataset.variantId || form.querySelector('input[name="id"]')?.value || 0);
      const trigger = form.querySelector("[data-quick-add-trigger]");
      const stepper = form.querySelector("[data-quick-stepper]");
      const countNode = form.querySelector("[data-stepper-count]");
      const cartItem = getCartItemForVariant(variantId);
      const quantity = cartItem ? Number(cartItem.quantity || 0) : 0;

      if (countNode) countNode.textContent = String(Math.max(quantity, 1));
      if (trigger) trigger.classList.toggle("is-hidden", quantity > 0);
      if (stepper) stepper.classList.toggle("is-hidden", quantity < 1);

      form.dataset.cartQuantity = String(quantity);
      form.dataset.cartItemKey = cartItem ? cartItem.key : "";
    });
  }

  function updateCollectionCartBars(cartState) {
    collectionCartState = cartState;
    if (!cartState) return;

    const headerCartButton = document.querySelector(".site-header .cart-button");
    if (headerCartButton) {
      headerCartButton.setAttribute("aria-label", "Cart, " + String(Number(cartState.item_count || 0)) + " items");
    }

    document.querySelectorAll(".site-header .cart-button [data-cart-count], .site-header .cart-button .cart-count-bubble [aria-hidden='true']").forEach(function (badge) {
      badge.textContent = String(Number(cartState.item_count || 0));
    });

    if (!collectionCartBars.length) {
      syncCollectionQuickAddForms();
      return;
    }

    collectionCartBars.forEach(function (bar) {
      const items = Array.isArray(cartState.items) ? cartState.items : [];
      const threshold = Number(bar.dataset.freeShippingThreshold || 39900);
      const giftOneThreshold = Number(bar.dataset.rewardGiftOneThreshold || 129900);
      const giftTwoThreshold = Number(bar.dataset.rewardGiftTwoThreshold || 179900);
      const giftOneLabel = bar.dataset.rewardGiftOneLabel || "Checked towel";
      const giftTwoLabel = bar.dataset.rewardGiftTwoLabel || "Grid towel";
      const rewardSubtotal = items.reduce(function (sum, item) {
        const properties = item && item.properties ? item.properties : {};
        return properties._kuuraii_reward_gift === "true" ? sum : sum + Number(item.original_line_price || item.final_line_price || 0);
      }, 0);
      const progress = giftTwoThreshold > 0 ? Math.min(100, Math.round((rewardSubtotal / giftTwoThreshold) * 100)) : 100;
      const message = bar.querySelector("[data-cartbar-message]");
      const kicker = bar.querySelector("[data-cartbar-kicker]");
      const summary = bar.querySelector("[data-cartbar-summary]");
      const count = bar.querySelector("[data-cartbar-count]");
      const progressNode = bar.querySelector("[data-cartbar-progress]");
      const thumbs = bar.querySelector(".collection-cartbar__thumbs");

      const isEmpty = Number(cartState.item_count || 0) === 0;
      bar.classList.toggle("is-empty", isEmpty);

      if (message) {
        if (isEmpty || rewardSubtotal < threshold) {
          message.textContent = "Add " + formatCollectionMoney(Math.max(0, threshold - rewardSubtotal)) + " more to unlock free delivery";
        } else if (rewardSubtotal < giftOneThreshold) {
          message.textContent = "Add " + formatCollectionMoney(giftOneThreshold - rewardSubtotal) + " to unlock " + giftOneLabel;
        } else if (rewardSubtotal < giftTwoThreshold) {
          message.textContent = "Add " + formatCollectionMoney(giftTwoThreshold - rewardSubtotal) + " to unlock " + giftTwoLabel;
        } else {
          message.textContent = "All available rewards unlocked";
        }
      }

      if (kicker) {
        kicker.hidden = true;
      }

      if (summary) {
        summary.hidden = true;
      }

      if (count) {
        count.textContent = Number(cartState.item_count || 0) === 1 ? "1 item" : String(Number(cartState.item_count || 0)) + " items";
      }

      if (progressNode) {
        progressNode.style.width = progress + "%";
      }

      if (thumbs) {
        thumbs.innerHTML = items
          .slice(0, 2)
          .map(function (item) {
            if (!item.image) return "";
            return '<img src="' + item.image + '" alt="' + (item.product_title || "Cart item").replace(/"/g, "&quot;") + '">';
          })
          .join("");
      }
    });

    syncCollectionQuickAddForms();
  }

  function fetchCollectionCartState() {
    return fetch("/cart.js", {
      headers: {
        Accept: "application/json"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart fetch failed");
      return response.json();
    });
  }

  function setCollectionQuickAddBusy(form, busy) {
    form.classList.toggle("is-loading", busy);
    form.querySelectorAll("button").forEach(function (button) {
      button.disabled = busy;
    });
  }

  function changeCollectionQuantity(form, nextQuantity) {
    const variantId = Number(form.dataset.variantId || form.querySelector('input[name="id"]')?.value || 0);
    const cartItem = getCartItemForVariant(variantId);
    const cartDrawer = document.querySelector("cart-drawer");
    const sectionRequest = cartDrawer
      ? {
          sections: cartDrawer.getSectionsToRender().map(function (section) {
            return section.id;
          }),
          sections_url: window.location.pathname
        }
      : {};
    const newLine = { id: variantId, quantity: Math.max(nextQuantity, 1) };

    const payload = cartItem && nextQuantity >= 0
      ? { id: cartItem.key, quantity: nextQuantity, ...sectionRequest }
      : { items: [newLine], ...sectionRequest };

    setCollectionQuickAddBusy(form, true);

    return fetch(cartItem ? "/cart/change.js" : "/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart request failed");
        return response.json();
      })
      .then(function (mutationResponse) {
        return fetchCollectionCartState().then(function (cartState) {
          return { mutationResponse: mutationResponse, cartState: cartState };
        });
      })
      .then(function (result) {
        if (cartDrawer && result.mutationResponse.sections && typeof cartDrawer.renderContents === "function") {
          result.mutationResponse.item_count = result.cartState.item_count;
          cartDrawer.renderContents(result.mutationResponse, false);
        }
        updateCollectionCartBars(result.cartState);
      })
      .finally(function () {
        setCollectionQuickAddBusy(form, false);
      });
  }

  /* Opens the single Kuuraii-owned cart drawer from collection quick-adds. */
  function openKuuraiiCartDrawer(trigger) {
  const cartDrawer = document.querySelector("cart-drawer");

  if (cartDrawer && typeof cartDrawer.open === "function") {
    cartDrawer.open(trigger || document.activeElement);
    return true;
  }

  return false;
}

if (collectionCartBars.length) {
  collectionCartBars.forEach(function (bar) {
    bar.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (openKuuraiiCartDrawer(bar)) {
        return;
      }

      window.location.href =
        bar.dataset.cartUrl || "/cart";
    });
  });

  fetchCollectionCartState()
    .then(updateCollectionCartBars)
    .catch(function () {});
}

  if (collectionQuickAdds.length) {
    fetchCollectionCartState()
      .then(updateCollectionCartBars)
      .catch(function () {});

    collectionQuickAdds.forEach(function (form) {
      form.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      const productCard = form.closest(".quick-product");
      const variantButtons = productCard ? Array.from(productCard.querySelectorAll("[data-collection-variant]")) : [];

      variantButtons.forEach(function (variantButton) {
        variantButton.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (variantButton.disabled) return;

          const variantId = Number(variantButton.dataset.variantId || 0);
          const variantAvailable = variantButton.dataset.variantAvailable === "true";
          const variantPreorder = variantButton.dataset.variantPreorder === "true";
          const hiddenVariantInput = form.querySelector('input[name="id"]');
          const preorderProperty = form.querySelector("[data-collection-preorder-property]");
          const trigger = form.querySelector("[data-quick-add-trigger]");
          const currentPrice = productCard.querySelector("[data-collection-current-price]");
          const comparePrice = productCard.querySelector("[data-collection-compare-price]");
          const meta = productCard.querySelector("[data-collection-variant-meta]");
          const detail = productCard.querySelector("[data-collection-variant-detail]");
          const badge = productCard.querySelector("[data-collection-variant-badge]");

          variantButtons.forEach(function (button) {
            const selected = button === variantButton;
            button.classList.toggle("is-selected", selected);
            button.setAttribute("aria-pressed", selected ? "true" : "false");
          });

          form.dataset.variantId = String(variantId);
          form.dataset.variantAvailable = String(variantAvailable);
          if (hiddenVariantInput) hiddenVariantInput.value = String(variantId);
          if (preorderProperty) preorderProperty.disabled = !variantPreorder;

          if (currentPrice) currentPrice.textContent = variantButton.dataset.variantPrice || "";
          if (comparePrice) {
            const compareValue = variantButton.dataset.variantComparePrice || "";
            comparePrice.textContent = compareValue;
            comparePrice.hidden = !compareValue;
          }
          if (meta) meta.textContent = variantPreorder ? "Pre-order available" : variantAvailable ? "Ready to ship" : "Sold out";
          if (detail) {
            const detailLabel = variantButton.dataset.variantDetailLabel || "Variant";
            const detailValue = variantButton.dataset.variantDetail || "";
            detail.textContent = "";
            if (detailValue) {
              const label = document.createElement("span");
              label.textContent = detailLabel;
              detail.appendChild(label);
              detail.appendChild(document.createTextNode(" " + detailValue));
            }
            detail.hidden = !detailValue;
          }
          if (badge) {
            const badgeValue = variantButton.dataset.variantBadge || "Freshly curated";
            badge.textContent = badgeValue;
            badge.classList.toggle("offer--discount", badgeValue.indexOf("% OFF") > -1);
          }
          if (trigger) {
            trigger.disabled = !variantAvailable && !variantPreorder;
            trigger.setAttribute("aria-label", (variantPreorder ? "Pre-order " : "Add ") + (form.dataset.productTitle || "product") + " — " + (variantButton.dataset.variantTitle || "selected variant"));
          }

          syncCollectionQuickAddForms();
        });
      });

      const stepper = form.querySelector("[data-quick-stepper]");
      if (stepper) {
        stepper.addEventListener("click", function (event) {
          const button = event.target.closest("[data-stepper-action]");
          if (!button) return;

          event.preventDefault();
          event.stopPropagation();

          const currentQuantity = Number(form.dataset.cartQuantity || 0);
          const nextQuantity = button.dataset.stepperAction === "decrease" ? Math.max(currentQuantity - 1, 0) : currentQuantity + 1;

          changeCollectionQuantity(form, nextQuantity).catch(function () {});
        });
      }
    });
  }

  /* Collection pagination is intentionally progressive: Shopify keeps the
     server-rendered first page fast, then the following pages are appended as
     the visitor approaches the end of the grid. */
  const collectionGrid = document.querySelector("#food-grid");
  const collectionPagination = document.querySelector("[data-collection-pagination]");

  function bindAppendedCollectionCard(productCard) {
    const form = productCard.querySelector(".kr-add-form[data-collection-quick-add='true']");
    if (!form || form.dataset.collectionInfiniteBound === "true") return;

    form.dataset.collectionInfiniteBound = "true";
    form.addEventListener("click", function (event) {
      event.stopPropagation();
    });

    const variantButtons = Array.from(productCard.querySelectorAll("[data-collection-variant]"));
    variantButtons.forEach(function (variantButton) {
      variantButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (variantButton.disabled) return;

        const variantId = Number(variantButton.dataset.variantId || 0);
        const available = variantButton.dataset.variantAvailable === "true";
        const preorder = variantButton.dataset.variantPreorder === "true";
        const hiddenInput = form.querySelector('input[name="id"]');
        const preorderProperty = form.querySelector("[data-collection-preorder-property]");
        const trigger = form.querySelector("[data-quick-add-trigger]");
        const currentPrice = productCard.querySelector("[data-collection-current-price]");
        const comparePrice = productCard.querySelector("[data-collection-compare-price]");
        const meta = productCard.querySelector("[data-collection-variant-meta]");
        const detail = productCard.querySelector("[data-collection-variant-detail]");
        const badge = productCard.querySelector("[data-collection-variant-badge]");

        variantButtons.forEach(function (button) {
          const selected = button === variantButton;
          button.classList.toggle("is-selected", selected);
          button.setAttribute("aria-pressed", selected ? "true" : "false");
        });
        form.dataset.variantId = String(variantId);
        form.dataset.variantAvailable = String(available);
        if (hiddenInput) hiddenInput.value = String(variantId);
        if (preorderProperty) preorderProperty.disabled = !preorder;
        if (currentPrice) currentPrice.textContent = variantButton.dataset.variantPrice || "";
        if (comparePrice) {
          const compare = variantButton.dataset.variantComparePrice || "";
          comparePrice.textContent = compare;
          comparePrice.hidden = !compare;
        }
        if (meta) meta.textContent = preorder ? "Pre-order available" : available ? "Ready to ship" : "Sold out";
        if (detail) {
          const label = variantButton.dataset.variantDetailLabel || "Variant";
          const value = variantButton.dataset.variantDetail || "";
          detail.textContent = "";
          if (value) {
            const labelNode = document.createElement("span");
            labelNode.textContent = label;
            detail.append(labelNode, document.createTextNode(" " + value));
          }
          detail.hidden = !value;
        }
        if (badge) {
          const badgeValue = variantButton.dataset.variantBadge || "Freshly curated";
          badge.textContent = badgeValue;
          badge.classList.toggle("offer--discount", badgeValue.indexOf("% OFF") > -1);
        }
        if (trigger) {
          trigger.disabled = !available && !preorder;
          trigger.setAttribute("aria-label", (preorder ? "Pre-order " : "Add ") + (form.dataset.productTitle || "product") + " — " + (variantButton.dataset.variantTitle || "selected variant"));
        }
        syncCollectionQuickAddForms();
      });
    });

    const stepper = form.querySelector("[data-quick-stepper]");
    if (stepper) {
      stepper.addEventListener("click", function (event) {
        const button = event.target.closest("[data-stepper-action]");
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        const quantity = Number(form.dataset.cartQuantity || 0);
        const next = button.dataset.stepperAction === "decrease" ? Math.max(quantity - 1, 0) : quantity + 1;
        changeCollectionQuantity(form, next).catch(function () {});
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
      changeCollectionQuantity(form, Math.max(Number(form.dataset.cartQuantity || 0) + 1, 1)).catch(function () {});
    });
  }

  if (collectionGrid && collectionPagination && window.IntersectionObserver) {
    let nextCollectionPage = collectionPagination.dataset.nextUrl || "";
    let isLoadingCollectionPage = false;
    const collectionPaginationStatus = collectionPagination.querySelector(".collection-infinite-pagination__status");

    function setCollectionLoadingState(loading, message) {
      isLoadingCollectionPage = loading;
      collectionPagination.classList.toggle("is-loading", loading);
      collectionPagination.setAttribute("aria-busy", loading ? "true" : "false");
      if (collectionPaginationStatus && message) collectionPaginationStatus.textContent = message;
    }

    function loadNextCollectionPage() {
      if (!nextCollectionPage || isLoadingCollectionPage) return;
      setCollectionLoadingState(true, "Loading more products…");

      fetch(nextCollectionPage, {
        credentials: "same-origin",
        headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" }
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Collection page failed to load");
          return response.text();
        })
        .then(function (markup) {
          const documentFragment = new DOMParser().parseFromString(markup, "text/html");
          const nextGrid = documentFragment.querySelector("#food-grid");
          const nextCards = nextGrid ? Array.from(nextGrid.querySelectorAll(".quick-product")) : [];
          const nextPager = documentFragment.querySelector("[data-collection-pagination]");

          if (!nextCards.length) {
            nextCollectionPage = "";
            collectionPagination.remove();
            return;
          }

          const appendedCards = nextCards.map(function (card) { return document.importNode(card, true); });
          appendedCards.forEach(function (card) {
            collectionGrid.appendChild(card);
            bindAppendedCollectionCard(card);
          });
          syncCollectionQuickAddForms();

          nextCollectionPage = nextPager ? nextPager.dataset.nextUrl || "" : "";
          if (!nextCollectionPage) {
            collectionPagination.remove();
          } else {
            collectionPagination.dataset.nextUrl = nextCollectionPage;
            setCollectionLoadingState(false, "Scroll to load more products");
          }
        })
        .catch(function () {
          setCollectionLoadingState(false, "Unable to load more products. Please scroll again.");
        });
    }

    const collectionPaginationObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextCollectionPage();
      });
    }, { rootMargin: "900px 0px" });

    collectionPaginationObserver.observe(collectionPagination);
  }

  document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
    const mainImage = gallery.querySelector(".kr-product-main-image");
    const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");

    if (!mainImage || !thumbs.length) return;

    function setMainImageMode(mode) {
      mainImage.dataset.mediaMode = mode === "document" ? "document" : "photo";
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        const imageUrl = thumb.getAttribute("data-image");
        if (!imageUrl) return;

        mainImage.src = imageUrl;
        setMainImageMode(thumb.getAttribute("data-media-mode"));
        thumbs.forEach(function (item) {
          item.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });
  });

  document.querySelectorAll("[data-product-root]").forEach(function (root) {
    const variantButtons = root.querySelectorAll("[data-variant-button]");
    const variantInput = root.querySelector("[data-variant-input]");
    const priceNode = root.querySelector("[data-product-price]");
    const compareNode = root.querySelector("[data-product-compare-price]");
    const badgeNode = root.querySelector("[data-product-badge]");
    const addToCart = root.querySelector("[data-add-to-cart]");
    const preorderProperty = root.querySelector("[data-preorder-property]");
    const selectedSizeDetail = root.querySelector("[data-selected-size-detail]");
    const selectedBedSize = root.querySelector("[data-selected-bed-size]");
    const selectedStockStatus = root.querySelector("[data-selected-stock-status]");

    if (!variantButtons.length || !variantInput) return;

    variantButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        variantButtons.forEach(function (item) {
          item.classList.remove("is-active");
        });
        button.classList.add("is-active");

        variantInput.value = button.dataset.variantId || "";
        if (priceNode) priceNode.textContent = button.dataset.variantPrice || "";
        if (compareNode) compareNode.textContent = button.dataset.variantCompare || "";
        if (badgeNode) badgeNode.textContent = button.dataset.variantBadge || "";

        const available = button.dataset.variantAvailable === "true";
        const preorder = button.dataset.variantPreorder === "true";
        if (addToCart) {
          addToCart.disabled = !available && !preorder;
          addToCart.textContent = preorder ? "Pre-order now" : available ? "Add to cart" : "Sold out";
        }
        if (preorderProperty) {
          preorderProperty.disabled = !preorder;
        }
        if (selectedSizeDetail) selectedSizeDetail.textContent = button.dataset.variantDetail || "";
        if (selectedBedSize && button.dataset.variantBedSize) selectedBedSize.textContent = button.dataset.variantBedSize;
        if (selectedStockStatus) selectedStockStatus.textContent = preorder ? "Pre-order" : available ? "Ready to ship" : "Sold out";
      });
    });
  });

  document.querySelectorAll("[data-quantity-stepper]").forEach(function (stepper) {
    const input = stepper.querySelector(".product-quantity__input");
    if (!input) return;

    function clampQuantity(nextValue) {
      const min = Number(input.min || 1);
      const max = input.max ? Number(input.max) : null;
      const safeValue = Math.max(min, Number.isFinite(nextValue) ? nextValue : min);
      return max ? Math.min(max, safeValue) : safeValue;
    }

    stepper.addEventListener("click", function (event) {
      const button = event.target.closest("[data-quantity-action]");
      if (!button) return;

      event.preventDefault();
      const currentValue = Number(input.value || input.min || 1);
      const direction = button.dataset.quantityAction === "decrease" ? -1 : 1;
      input.value = String(clampQuantity(currentValue + direction));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    input.addEventListener("input", function () {
      const numericValue = parseInt(input.value.replace(/[^0-9]/g, ""), 10);
      input.value = String(clampQuantity(numericValue));
    });

    input.addEventListener("blur", function () {
      input.value = String(clampQuantity(Number(input.value || input.min || 1)));
    });
  });

  document.querySelectorAll(".kr-add-form[data-ajax-cart='true']").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      const submitter = event.submitter || form.querySelector('[type="submit"]');
      if (!submitter || submitter.name === "checkout") return;

      if (form.dataset.collectionQuickAdd === "true") {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
        changeCollectionQuantity(form, Math.max(Number(form.dataset.cartQuantity || 0) + 1, 1)).catch(function () {});
        return;
      }

      event.preventDefault();
      const formData = new FormData(form);
      const originalLabel = submitter.textContent;
      const cartDrawer = document.querySelector("cart-drawer");

      submitter.disabled = true;
      submitter.textContent = "Adding...";

      if (cartDrawer) {
        formData.append(
          "sections",
          cartDrawer
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
        );
        formData.append("sections_url", window.location.pathname);
        cartDrawer.setActiveElement(document.activeElement);
      }

      fetch(window.routes && routes.cart_add_url ? routes.cart_add_url : "/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart request failed");
          return response.json();
        })
        .then(function (response) {
          if (response.status) throw new Error(response.description || "Cart request failed");
          if (cartDrawer && typeof cartDrawer.renderContents === "function") {
            cartDrawer.renderContents(response);
          }
          fetch("/cart.js", {
            headers: {
              Accept: "application/json"
            }
          })
            .then(function (cartResponse) {
              if (!cartResponse.ok) throw new Error("Cart fetch failed");
              return cartResponse.json();
            })
            .then(updateCollectionCartBars)
            .catch(function () {});
          submitter.textContent = "Added";
        })
        .catch(function () {
          submitter.textContent = "Try again";
        })
        .finally(function () {
          setTimeout(function () {
            submitter.disabled = false;
            submitter.textContent = originalLabel;
          }, 1400);
        });
    });
  });
});
